import { useEffect, useState } from 'react'

export const useIsScrolled = (ref: React.RefObject<HTMLElement>): boolean => {
    const [isScrolled, setIsScrolled] = useState(false)

    useEffect(() => {
        const element = ref.current
        if (!element) return

        const checkScroll = () => {
            setIsScrolled(element.scrollTop > 0 || element.scrollLeft > 0)
        }

        element.addEventListener('scroll', checkScroll)

        // Check initial state
        checkScroll()

        return () => {
            element.removeEventListener('scroll', checkScroll)
        }
    }, [ref])

    return isScrolled
}

export default useIsScrolled
